
import { Box, Button, CircularProgress, IconButton, Typography, useTheme } from '@mui/material'
import React, { useState, useEffect } from 'react'
import useResponsive from '../../hooks/useResponsive'
import { Timer } from '@mui/icons-material'
import CommonButton from '../CommonButton'
import TimerProjectSelectionModal from './TimerProjectSelectionModal'
import { useTimerContext } from '../../contexts/TimerContext'
import TimerMobilePopup from './TimerMobilePopup'
import { delay, formatTime } from '../../utils/commonMethods'
import LocalStorageUtil from '../../utils/localStorageUtil'
import { storageKeys } from '../../utils/constants'
import apiService from '../../apiService/ApiService'
import { AxiosResponse, SaveWorkerHoursLogging } from '../../utils/urlConst'
import { useAlert } from '../../contexts/AlertContext'
import { useNavigate } from 'react-router-dom'
import { t } from 'i18next';

export default function WorkLog() {
    const [isRunning, setIsRunning] = useState(false)
    const [isProjectPopup, setIsProjectPopup] = useState(false)
    const [elapsedTime, setElapsedTime] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const theme = useTheme()
    const { isMobile } = useResponsive();
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const { startTime, isTimerOn, setStartTime, setIsTimerOn,
        selectedProjectForLog, setSelectedProjectForLog, isResetTimer, setIsResetTimer, selectedProjectIdForNavigation } = useTimerContext();
    const { showAlert } = useAlert();
    const navigate = useNavigate();

    // const open = Boolean(anchorEl);
    // const id = open ? 'simple-popover' : undefined;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const startTimer = () => {
        if (selectedProjectForLog.id) {
            const startTime = new Date().getTime()
            setStartTime(startTime);
            setIsTimerOn(true);
            setIsRunning(true);
        } else {
            setIsProjectPopup(true)
        }
    }

    const stopTimer = () => {
        setIsTimerOn(false)
        setStartTime(null)
        handleSaveEndTime()
    }

    const handleSaveEndTime = () => {
        const projectId = selectedProjectForLog?.id ?? 0
        const now = new Date()
        const endTime = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`
        console.log("endTime", endTime)
        saveProjectLogToServer(projectId, null, endTime)
            .finally(() => {
                setSelectedProjectForLog({
                    id: null,
                    name: null,
                })
                setElapsedTime(0);
                handleClose();
            }
            )
    }
    // fetch ProjectList api call
    const saveProjectLogToServer = async (projectId: number, startTime: string | null, endTime: string | null) => {
        try {
            setIsLoading(true)
            let userToken = LocalStorageUtil.getItem(storageKeys.authToken, "");
            let userId = LocalStorageUtil.getItem(storageKeys.userId, "");
            let medwerkerId = LocalStorageUtil.getItem(storageKeys.workerId, "");

            let jsondata = JSON.stringify({
                token: userToken,
                user_id: userId,
                medewerker_id: medwerkerId,
                project_id: projectId,
                start_time: startTime,
                end_time: endTime,
            });

            apiService.setAuthToken(userToken);
            const responseJson: AxiosResponse | null = await apiService.post(SaveWorkerHoursLogging, jsondata);
            if (responseJson?.hasOwnProperty('status') && responseJson?.status_code === 1) {
                console.log(" saveProjectLogToServer responseJson", responseJson)
                showAlert(startTime ? t("timer.projectStarted") : t("timer.projectLogged"), "success")
            } else if (responseJson?.hasOwnProperty('status') && (responseJson?.status_code === 2 || responseJson?.status_code === 0)) {
                LocalStorageUtil.clear();
                navigate("/login");
            } else if (responseJson?.hasOwnProperty('status') && responseJson?.status_code === 3) {
                showAlert(t("taskOverView.no_projects_associated_with_worker"), "info")
                setIsLoading(false);
            } else {
                showAlert(t("common.server_error"), 'error')
                setIsLoading(false);
            }
        } catch (error) {
            showAlert(t("common.server_error"), 'error')
        } finally {
            setIsLoading(false);
        }
    };

    const resetAction = async () => {
        setIsTimerOn(false);
        setStartTime(null);
        setIsRunning(false);
        setElapsedTime(0);
        await delay(100);
        startTimer();
    }

    useEffect(() => {
        if (isResetTimer) {
            resetAction()
            setIsResetTimer(false)
        }
    }, [isResetTimer])

    useEffect(() => {
        if (isTimerOn) {
            setIsRunning(true)
            if (startTime) {
                const currentTime = new Date().getTime()
                setElapsedTime(Math.floor((currentTime - startTime) / 1000))
            } else {
                const startTime = new Date().getTime()
                setElapsedTime(0)
                setStartTime(startTime);
            }
        } else {
            setIsRunning(false)
            setElapsedTime(0)
        }
    }, [isTimerOn])

    useEffect(() => {
        console.log("isResetTimer", isResetTimer)
        let interval: ReturnType<typeof setInterval> | null = null
        if (isRunning) {
            interval = setInterval(() => {
                if (startTime) {
                    const currentTime = new Date().getTime()
                    setElapsedTime(Math.floor((currentTime - startTime) / 1000))
                }
            }, 1000)
        } else if (interval) {
            clearInterval(interval)
        }
        return () => {
            if (interval) clearInterval(interval)
        }
    }, [isRunning])


    return (
        <Box sx={{ flexDirection: "row", display: "flex", mx: 2, alignItems: "center" }}>
            {isLoading ?
                <CircularProgress size={"30px"} sx={{ mx: 4 }} />
                :
                isMobile ?
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        borderRadius: "8px",
                        border: 1,
                        backgroundColor: theme.palette.blueColors.main
                    }}>
                        <IconButton size="small"
                            onClick={handleClick}
                        >
                            <Timer fontSize="medium" sx={{ color: theme.palette.greyColors.main }} />
                        </IconButton>
                    </Box> :
                    <Box sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <Button variant="text"
                            sx={{ color: theme.palette.blueColors.main }}
                            onClick={() => setIsProjectPopup(true)}>
                            <Typography sx={{ fontFamily: "Nunito Sans SemiBold", fontSize: "20px" }}>{selectedProjectForLog.id ? selectedProjectForLog.name : "Selecteer project"}</Typography>
                        </Button>
                        {!isRunning ? (
                            <CommonButton
                                translationKey={"timer.start"}
                                onClick={startTimer}
                                fullWidth={false}
                                sx={{
                                    fontFamily: "Nunito Sans Regular500",
                                    fontWeight: 700,
                                    width: "50px",
                                    backgroundColor: "primary.main",
                                    color: theme.palette.secondary.main,
                                    mx: 3
                                }}
                            />
                        ) :
                            (
                                <CommonButton
                                    translationKey={"timer.stop"}
                                    onClick={stopTimer}
                                    fullWidth={false}
                                    sx={{
                                        fontFamily: "Nunito Sans Regular500",
                                        fontWeight: 700,
                                        width: "50px",
                                        backgroundColor: "error.dark",
                                        color: theme.palette.secondary.main,
                                        mx: 3
                                    }}
                                />
                            )}
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mr: 3 }}>
                            <Timer fontSize="medium" sx={{ color: theme.palette.primary.main, mr: 1 }} />
                            <Typography
                                sx={{
                                    fontFamily: "Nunito Sans Bold",
                                    fontSize: "24px",
                                    color: theme.palette.blueColors.main
                                }}>
                                {formatTime(elapsedTime)}
                            </Typography>
                        </Box>
                    </Box>
            }
            <TimerProjectSelectionModal
                handleClose={() => {
                    setIsProjectPopup(false)
                }}
                isVisible={isProjectPopup}
                isAnotherProject={selectedProjectForLog.id !== null && selectedProjectIdForNavigation !== null && selectedProjectForLog.id !== selectedProjectIdForNavigation}
                isDropdownDiabled={selectedProjectForLog.id !== null && selectedProjectIdForNavigation !== null && selectedProjectForLog.id !== selectedProjectIdForNavigation}
            />
            <TimerMobilePopup anchorEl={anchorEl} handleClose={handleClose} elapsedTime={elapsedTime} />
        </Box >
    )
}

